import { render, staticRenderFns } from "./MenuConfigChips.vue?vue&type=template&id=5dc61b4e&"
import script from "./MenuConfigChips.vue?vue&type=script&lang=js&"
export * from "./MenuConfigChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports